import * as React from 'react'
import { pillVariants, type PillVariantProps } from './Pill.variants'
import { cn } from '../../utils/cn'

export type PillProps = PillVariantProps &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children: React.ReactNode
    active?: boolean
  }

export default function Pill({ state, active, className, children, ...rest }: PillProps) {
  const resolvedState = state ?? (active ? 'active' : 'inactive')
  return (
    <button className={cn(pillVariants({ state: resolvedState }), className)} {...rest}>
      {children}
    </button>
  )
}
